<mat-dialog-content>
  <lemon-dialog-header> Ilmoita AI-kirjausehdotuksesta </lemon-dialog-header>

  @if (data.naytettavaKirjaus.kirjaus.ehdotus; as ehdotus) {
    <div class="dark-gray-text" style="font-size: 12px; margin-bottom: 12px">
      <div>Varmuustaso: {{ ehdotus.confidenceLevel }} %</div>
      @if (ehdotus.perustelu) {
        <div style="margin-top: 4px">{{ ehdotus.perustelu }}</div>
      }
    </div>
  }

  <div>Onko kirjausehdotus väärin? Ilmoita siitä kehitykseen niin voimme parantaa mallia. Tositteen, ehdotuksen ja kirjauksen tiedot liitetään automaattisesti.</div>

  <form novalidate style="margin-top: 8px">
    <mat-form-field style="width: 100%">
      <textarea matInput rows="4" tahtiOhjeeseen [formField]="lomake.palaute" placeholder="Palaute"></textarea>
      <mat-hint align="end">{{ lomake.palaute().value()?.length ?? 0 }} / {{ maxPituus }}</mat-hint>
      @if (onkoVirhe(lomake.palaute, 'required') && (lomake.palaute().dirty() || lomake.palaute().touched())) {
        <mat-error> Kirjoita palaute </mat-error>
      }
      @if (onkoVirhe(lomake.palaute, 'maxLength') && (lomake.palaute().dirty() || lomake.palaute().touched())) {
        <mat-error> Palaute on liian pitkä (max {{ maxPituus }} merkkiä) </mat-error>
      }
    </mat-form-field>
  </form>
</mat-dialog-content>
<mat-dialog-actions style="padding-left: 0; padding-right: 0; gap: 8px">
  <app-secondary-button [focusRegionStart]="true" mat-dialog-close actionId="Peruuta (ilmoita ai-ehdotuksesta dialog)">Peruuta</app-secondary-button>
  <app-primary-button (click)="laheta()" [disabled]="lahetetaan()" actionId="Lähetti AI-kirjausehdotuksen palautteen">Lähetä</app-primary-button>
</mat-dialog-actions>
